import React from 'react';

import { IModalProps } from 'views/Offers/RollingOffers/Form/RollingOfferForm.types';

import DialogModal from 'components/DialogModal/DialogModal';

const RollingOfferModals: React.FC<IModalProps> = ({
  isSaveDialogOpen,
  isUpdateDialogOpen,
  setIsSaveDialogOpen,
  setIsUpdateDialogOpen,
  submitForm
}): React.ReactElement => {
  return (
    <React.Fragment>
      {isUpdateDialogOpen && (
        <DialogModal
          isOpen={isUpdateDialogOpen}
          title="Rolling Offer is currently live"
          description="Your changes will update automatically"
          dataTestId="rollingOfferUpdateDialog"
          modalActions={{
            onConfirm: {
              label: 'Update',
              action: submitForm
            },
            onClose: {
              label: 'Cancel',
              action: () => setIsUpdateDialogOpen(false),
              variant: 'outline'
            }
          }}
        />
      )}
      {isSaveDialogOpen && (
        <DialogModal
          isOpen={isSaveDialogOpen}
          title="Please note"
          description="No products were selected"
          modalActions={{
            onConfirm: {
              label: 'Save',
              action: submitForm
            },
            onClose: {
              label: 'Cancel',
              action: () => setIsSaveDialogOpen(false),
              variant: 'outline'
            }
          }}
        />
      )}
    </React.Fragment>
  );
};

export default RollingOfferModals;
